// extracted by mini-css-extract-plugin
export default {"component":"SetupForm_component__+9lO4","buttonWrap":"SetupForm_buttonWrap__+OybF","error":"SetupForm_error__jZmwr","dark":"SetupForm_dark__L6+U5"};